import axios from 'axios';
// import UserService from '@/services/api/user.service'
// import store from '@/store/store'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});

/*
 * The interceptor here ensures that we check for the token in local storage every time an http request is made
 */
http.interceptors.request.use(
    request => {
      const token = localStorage.getItem('authToken');
      if (token) {
        request.headers['Authorization'] = `Bearer ${token}`;
      }
      return request;
    },
    (error: any) => {
      return Promise.reject(error);
    }
);

http.interceptors.response.use(
    (response: any) => response,
    (err: any) => {
      console.log('request failed:', err);

      // TODO: This has been deleted to make tests pass. Find a way to send alert from elsewhere
      // store.dispatch('SET_ALERT_MESSAGE', 'Something went wrong. Please try logging out and try again or contact the webmaster.')
      return Promise.reject(err);
    }
);

export default http;
